export var smaReview = {
  // Client and contributor review
  msgErrorSenderId: 'Sie können diesen Antrag nicht verfolgen',
  msgClaimNumber: 'Nummer',
  msgClaimName: 'Name',
  msgYourReview: 'Bitte verfassen Sie Ihre Kommentare unten',
  msgSend: 'Abschicken',
  msgWarningEmptyReview: 'Sind Sie sicher, dass Sie eine Bewertung ohne detailliertes Feedback abgeben möchten?',
  msgNoReviews: 'Noch keine Bewertungen'
};